import React, { useState, useEffect } from "react";
import Nav from "./Navigation";
import { getTokenInternal } from "./useToken";

const FriendSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [allFriends, setAllFriends] = useState([]);
  const [friendRequestSent, setFriendRequestSent] = useState(false);
  const [showBlockedUsers, setShowBlockedUsers] = useState(false);

  useEffect(() => {
    const fetchFriends = async () => {
      try {
        const token = await getTokenInternal();

        if (token) {
          const url = `${process.env.REACT_APP_API_HOST}/api/friendsList`;
          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access_token}`,
              "Content-Type": "application/json",
            },
          });
          if (response.ok) {
            const data = await response.json();
            setAllFriends(data);
          }
        }
      } catch (error) {
        console.error("Error fetching pending friend requests:", error);
      }
    };

    // Fetch pending friend requests when the component mounts and whenever the user changes
    fetchFriends();
  }, []);




  useEffect(() => {
    const getBlockedUsers = async () => {
      try {
        const token = await getTokenInternal();

        if (token) {
          const url = `${process.env.REACT_APP_API_HOST}/api/blocked`;
          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access_token}`,
              "Content-Type": "application/json",
            },
          });
          if (response.ok) {
            const data = await response.json();
            setBlockedUsers(data);
          }
        }
      } catch (error) {
        console.error("Error fetching blocked users:", error);
      }
    };

    // Fetch blocked users when the component mounts and whenever the user changes
    getBlockedUsers();
  }, []);




  useEffect(() => {
    const fetchSearchResults = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/accounts?query=${searchTerm}`
        );
        const data = await response.json();
        setSearchResults(data);
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    };

    if (searchTerm.trim() !== "") {
      fetchSearchResults();
    } else {
      setSearchResults([]);
    }
  }, [searchTerm]);



  useEffect(() => {
    const fetchPendingRequests = async () => {
      try {
        const token = await getTokenInternal();

        if (token) {
          const url = `${process.env.REACT_APP_API_HOST}/api/pending-with-usernames`;
          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access_token}`,
              "Content-Type": "application/json",
            },
          });
          if (response.ok) {
            const data = await response.json();
            setCurrentUser(token.account.username);
            setPendingRequests(data);
          }
        }
      } catch (error) {
        console.error("Error fetching pending friend requests:", error);
      }
    };

    // Fetch pending friend requests when the component mounts and whenever the user changes
    fetchPendingRequests();
  }, []);



  const handleFriendSelect = (friend) => {
    setSelectedFriend(friend);
    setFriendRequestSent(false); // Reset friendRequestSent when the selected friend changes
  };

  const handleFriendRequest = async () => {
    try {
      const token = await getTokenInternal();

      if (token && selectedFriend) {
        const url = `${process.env.REACT_APP_API_HOST}/api/friends/${selectedFriend.id}`;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            friend_id: selectedFriend.id,
          }),
        });
        if (response.ok) {
          // Handle success, e.g., show a success message or update UI
          setFriendRequestSent(true);
        } else {
          // Handle errors, e.g., show an error message or handle specific cases
          console.error("Error sending friend request:", response.statusText);
        }
      }
    } catch (error) {
      console.error("Error sending friend request:", error);
    }
  };


const handleSearchedBlockUser = async (friend) => {
  try {
    const token = await getTokenInternal();


    // Block the user
    const blockUrl = `${process.env.REACT_APP_API_HOST}/api/block/${friend.id}`;
    await fetch(blockUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        "Content-Type": "application/json",
      },
    });

  } catch (error) {
    console.error("Error declining friend request:", error);
  }
};






const handleBlockUser = async (friend) => {
  try {
    const token = await getTokenInternal();

    // Decline friend request
    const declineUrl = `${process.env.REACT_APP_API_HOST}/api/friends/decline/${friend.user_id}`;
    await fetch(declineUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        "Content-Type": "application/json",
      },
    });
    setPendingRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== friend.id)
    );

    // Block the user
    const blockUrl = `${process.env.REACT_APP_API_HOST}/api/block/${friend.user_id}`;
    await fetch(blockUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        "Content-Type": "application/json",
      },
    });

    // Update the UI
    setPendingRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== friend.id)
    );

    // Fetch blocked user's information
    const blockedUserUrl = `${process.env.REACT_APP_API_HOST}/api/accounts/${friend.user_id}`;
    const blockedUserResponse = await fetch(blockedUserUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        "Content-Type": "application/json",
      },
    });

    if (blockedUserResponse.ok) {
      const blockedUserData = await blockedUserResponse.json();

      // Add the blocked user to the state
      setBlockedUsers((prevBlockedUsers) => [
        ...prevBlockedUsers,
        blockedUserData,
      ]);
    }
  } catch (error) {
    console.error("Error declining friend request:", error);
  }
};




  const handleAcceptFriendRequest = async (friend) => {
    try {
      const token = await getTokenInternal();

      if (token && friend) {
        const url = `${process.env.REACT_APP_API_HOST}/api/friends/accept/${friend.user_id}`;
        await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
        });

        // Update the UI
        setPendingRequests((prevRequests) =>
          prevRequests.filter((request) => request.id !== friend.id)
        );

        // Fetch the updated friend list after accepting the request
        const updatedFriendsResponse = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/friendsList`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access_token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (updatedFriendsResponse.ok) {
          const updatedFriendsData = await updatedFriendsResponse.json();
          setAllFriends(updatedFriendsData);
        }
      }
    } catch (error) {
      console.error("Error accepting friend request:", error);
    }
  };





  const handleDeclineFriendRequest = async (friend) => {
    try {
      const token = await getTokenInternal();

      const url = `${process.env.REACT_APP_API_HOST}/api/friends/decline/${friend.user_id}`;
      await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token.access_token}`,
          "Content-Type": "application/json",
        },
      });
      setPendingRequests((prevRequests) =>
        prevRequests.filter((request) => request.id !== friend.id)
      );
    } catch (error) {
      console.error("Error declining friend request:", error);
    }
  };

  const handleRemoveFriendRequest = async (friend) => {
    try {
      const token = await getTokenInternal();
      if (token && friend) {
        const url = `${process.env.REACT_APP_API_HOST}/api/friends/${friend.user_id}`;
        await fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
        });
        const urls = `${process.env.REACT_APP_API_HOST}/api/friends/${friend.friend_id}`;
        await fetch(urls, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
        });

        // Update the UI
        setAllFriends((prevFriends) =>
          prevFriends.filter((friendItem) => friendItem.id !== friend.id)
        );
      }
    } catch (error) {
      console.error("Error removing friend:", error);
    }
  };

  const handleUnblockUser = async (blockedUser) => {
    try {
      const token = await getTokenInternal();

      if (token && blockedUser) {
        const url = `${process.env.REACT_APP_API_HOST}/api/unblock/${blockedUser.blocked_user_id}`;
        await fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
        });

        // Update the UI
        setBlockedUsers((prevBlockedUsers) =>
          prevBlockedUsers.filter(
            (user) => user.blocked_user_id !== blockedUser.blocked_user_id
          )
        );
      }
    } catch (error) {
      console.error("Error unblocking user:", error);
    }
  };

  const handleShowBlockedUsers = () => {
    setShowBlockedUsers(!showBlockedUsers);
  };

  return (
    <div>
      <Nav />
      <div className="mt-4 ml-4 mr-4 font-bold">
        <input
          type="text"
          placeholder="Search for friends"
          className="border border-gray-300 p-2 rounded-md focus:outline-none focus:border-blue-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {searchResults.length > 0 && (
          <ul className="mt-2">
            {searchResults
              .filter((friend) => friend.username !== currentUser)
              .map((friend) => (
                <li
                  key={friend.id}
                  className="flex items-center justify-between bg-white border border-gray-300 p-2 rounded-md mt-2"
                >
                  <span>{friend.username}</span>
                  <div>
                    {!friendRequestSent ? (
                      <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 mr-2"
                        onClick={() => handleFriendSelect(friend)}
                      >
                        Add Friend
                      </button>
                    ) : (
                      <p> </p>
                    )}
                    <button
                      className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
                      onClick={() => handleSearchedBlockUser(friend)}
                    >
                      Block User
                    </button>
                  </div>
                </li>
              ))}
          </ul>
        )}

        {selectedFriend && (
          <div className="mt-4">
            <p className="text-lg font-semibold">
              Selected Friend: {selectedFriend.username}
            </p>
            {!friendRequestSent ? (
              <div className="items-center">
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                  onClick={handleFriendRequest}
                >
                  Confirm Friend Request to {selectedFriend.username}!
                </button>
              </div>
            ) : (
              <p className="text-green-500">Friend request sent!</p>
            )}
          </div>
        )}

        {pendingRequests.length > 0 && (
          <div className="mt-4 text-white border-b-4">
            <p className="text-lg font-semibold">Pending Friend Requests:</p>
            <ul>
              {pendingRequests.map((request) => (
                <li className="text-lg flex border-b-2" key={request.id}>
                  <div className="mb-8">
                    <button
                      className="text-sm bg-blue-500 text-white px-4 py-0 rounded-md hover:bg-blue-600 mr-2"
                      onClick={() => handleAcceptFriendRequest(request)}
                    >
                      Accept
                    </button>
                    <button
                      className="text-sm bg-red-500 text-white px-4 py-0 rounded-md hover:bg-red-600 mr-2"
                      onClick={() => handleDeclineFriendRequest(request)}
                    >
                      Decline
                    </button>
                    <button
                      className="mr-4 text-sm bg-red-500 text-white px-4 py-0 rounded-md hover:bg-red-600"
                      onClick={() => handleBlockUser(request)}
                    >
                      Block User
                    </button>
                  </div>
                  {request && request.username
                    ? request.username
                    : "Unknown User"}
                </li>
              ))}
            </ul>
          </div>
        )}

        {allFriends.length > 0 && (
          <div className="mt-4 text-white">
            <p className="text-lg font-semibold">My Friends:</p>
            <ul>
              {allFriends.map((request) => (
                <li className="text-xl flex mt-4 border-b-2" key={request.id}>
                  <div className="row-end-4">
                    <button
                      className="text-sm bg-blue-500 text-white px-4 py-0 rounded-md hover:bg-blue-600 mr-2"
                      onClick={() => handleRemoveFriendRequest(request)}
                    >
                      Remove
                    </button>
                    <span>
                      {request.friend_username || "Unknown User"}
                      <div className="flex ml-8">
                        {request.visible ? (
                          <span> Discord: {request.discord_name || "N/A"}</span>
                        ) : (
                          <span> Discord: N/A</span>
                        )}
                      </div>
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {showBlockedUsers && blockedUsers.length > 0 && (
          <div className="mt-4 text-white">
            <p className="text-lg font-semibold">Blocked Users:</p>
            <ul>
              {blockedUsers.map((blockedUser) => (
                <li
                  className="text-xl flex mt-4 border-b-2"
                  key={blockedUser.blocked_user_id}
                >
                  {/* Display blocked user information similar to friend entries */}
                  <div className="row-end-4">
                    <button
                      className="text-sm bg-red-500 text-white px-4 py-0 rounded-md hover:bg-red-600"
                      onClick={() => handleUnblockUser(blockedUser)}
                    >
                      Unblock
                    </button>
                  </div>
                  <div className="ml-4">
                    {blockedUser.username
                      ? blockedUser.username
                      : "Unknown User"}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Button to show blocked users */}
        {!showBlockedUsers && (
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded-md mt-4"
            onClick={handleShowBlockedUsers}
          >
            Show Blocked Users
          </button>
        )}
      </div>
    </div>
  );
};

export default FriendSearch;
